<template>
  <div>
    <ed-audiometro  :key="$root.$session.versao" :intId="0"/>
  </div>
</template>

<script>
import EdAudiometro from "@/components/audiometria/audiometro/editar";
export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdAudiometro },
  mounted() {
  },
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>